import { Box, Typography, Alert, Snackbar, Grid } from '@mui/material';
import { useState } from 'react';
import { useAuth } from '../../auth/useAuth';
import { CgmSnapshotWidget, ContextNoteForm } from '../../components/patient';
import { markPatientCheckinCompleted } from '../../utils/patientCheckinStore';

interface ContextNoteInput {
  ts: string;
  noteText?: string;
  mood?: number;
  stress?: number;
  sleepHours?: number;
  symptoms?: string[];
}

export const ContextCheckinPage = () => {
  const { user } = useAuth();
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (note: ContextNoteInput) => {
    // TODO: Connect to API
    console.log('Context note:', note);
    markPatientCheckinCompleted(user?.id, user?.displayName);
    setShowSuccess(true);
    await new Promise(resolve => setTimeout(resolve, 500));
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Daily Check-in
      </Typography>
      <Typography color="text.secondary" paragraph>
        Help us understand your overall well-being today.
      </Typography>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <CgmSnapshotWidget />
        </Grid>
      </Grid>

      <ContextNoteForm onSubmit={handleSubmit} />

      <Snackbar
        open={showSuccess}
        autoHideDuration={3000}
        onClose={() => setShowSuccess(false)}
      >
        <Alert severity="success" onClose={() => setShowSuccess(false)}>
          Check-in saved successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};
